<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">

    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">SERVIZIO</a>
      </label>
    </div>
    
    <div class="button-wrapper">
      <button class="btn btn-white vertical full-width-btn align-items-center" routerLink="/servizi/nuovo" *ngIf="!groups.includes('partner')">
        Aggiungi Servizio<i class="ml-30 fas fa-plus"></i>
      </button>
    </div>

    <hr class="gold-hr">

    <section class="main-content wrapper content-padding">
      <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
      <div
        class="custom-data-output has-margin-top"
        role="table"
        id="elencoConsegnePartner"
      >
        <form  class="table-row-container row first-row filter" [formGroup]="serviceFilterForm" (ngSubmit)="filter()" *ngIf="serviceFilterForm">
          <div class="item data-col-10">
            <h4 class="title" (click)="navigateOrder('Service.id')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Service.id')"></i>
              ID
            </h4>
            <span class="data">
              <input type="number" formControlName="Service.id" min="1000" max="10000" >
            </span>
          </div>

          <div class="item data-col-10">
            <h4 class="title">Foto</h4>
            <span class="data"></span>
          </div>

          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('Service.serviceName')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Service.serviceName')"></i>
              Nome Servizio
            </h4>
            <span class="data">
              <input type="text" formControlName="Service.serviceName" >  
            </span>
          </div>

          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('Service.pricingModel')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Service.pricingModel')"></i>
              Tipo Servizio
            </h4>
            <span class="data">
              <select formControlName="Service.pricingModel">
                <option value="">Tutti</option>
                  <option value="fixedprice">Servizi a Prezzo Fisso</option>
                  <option value="hourlyrate">Services in Ora</option>
                  <option value="sales">Servizi Vendita</option>
                  <option value="corporate">Servizio Aziendale</option>
                  <option value="warehouseservice">Servizio Magazzino</option>
              </select>
            </span>
          </div>

          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('Service.hideCustomerInformation')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Service.hideCustomerInformation')"></i>
              Nascondi mittente e destinatario
            </h4>
            <span class="data">
              <select formControlName="Service.hideCustomerInformation">
                <option value="">Tutti</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </span>
          </div>

          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('Service.notes')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Service.notes')"></i>
              Note
            </h4>
            <span class="data">
              <input type="text" formControlName="Service.notes" > 
            </span>
          </div>

          <div class="item nowrap">
            <h4 class="title hide-on-mobile">AZIONI</h4>
            <span class="data-row-left btn-container btn-container-actions">
              <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                RICERCA <i class="fas fa-search"></i></button>
                <br/>
              <button class="btn vertical align-items-center" (click)="fnReset();">
                RESET <i class="fas fa-times-circle"></i></button>
            </span>
          </div>
        </form>

        <div class="table-row-container row" *ngFor="let service of services">
          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              ID
            </h4>
            <div class="data data-id">
              <div>{{ service.id }}</div>
            </div>
          </div>

          <div class="item data-col-10">
            <h4 class="title">Foto</h4>
            <span class="data" style="cursor: pointer;">
              <img 
                [src]="service?.image || 'assets/img/no-image.jpg'" 
                [alt]="service?.serviceName || 'Servizo'"
                class="product-image" 
                (click)="openImage($event)"
              >
            </span>
          </div>

          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              Nome Servizio
            </h4>
            <div class="data">
              <div>{{ service?.serviceName || "N/A" }}</div>
            </div>
          </div>

          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              Tipo Servizio
            </h4>
            <div class="data">
              {{ service?.pricingModel | serviceName }} 
            </div>
          </div>

          <div class="item data-col-20">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              Nascondi mittente e destinatario
            </h4>
            <div class="data">
              <div>{{ service?.hideCustomerInformation ? "Yes" : "No" }}</div>
            </div>
          </div>

          <div class="item data-col-10">
            <h4 class="title">
              <i class="sort-icon fas"></i>
              Notes
            </h4>
            <div class="data">
              <div>{{ service?.notes || "N/A" }}</div>
            </div>
          </div>

          <div class="item nowrap">
            <span class="data-row-left btn-container btn-container-actions">
              <button class="btn vertical align-items-center" *ngIf="groups.includes('admin') || groups.includes('operation')" [routerLink]="['/servizi', service.id, 'edit']">
                Modifica
              </button>
              <button class="btn btn-red vertical align-items-center" *ngIf="groups.includes('admin') || groups.includes('operation')" (click)="$event.preventDefault(); deleteService(service.id)">
                Elimina<i class="ml-10 far fa-trash-alt"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
    </section>
  </div>
</section>


<!--
<section class="title-bar content-padding first-item">
  <div class="wrapper nowrap">
    <h2 class="title-heading">Servizio</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
        <button class="btn btn-white vertical full-width-btn align-items-center" routerLink="/servizi/nuovo" *ngIf="!groups.includes('partner')">
          Aggiungi Servizio<i class="ml-30 fas fa-plus"></i>
        </button>
      </span>
    </div>
  </div>
</section>
<section class="main-content wrapper content-padding">
  <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)">
  </app-pagination>
  <div
    class="custom-data-output has-margin-top"
    role="table"
    id="elencoConsegnePartner"
  >
    <form  class="table-row-container row first-row filter" [formGroup]="serviceFilterForm" (ngSubmit)="filter()" *ngIf="serviceFilterForm">
      <div class="item data-col-10">
        <h4 class="title" (click)="navigateOrder('Service.id')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Service.id')"></i>
          ID
        </h4>
        <span class="data">
          <input type="number" formControlName="Service.id" min="1000" max="10000" >
        </span>
      </div>

      <div class="item data-col-10">
        <h4 class="title">Foto</h4>
        <span class="data"></span>
      </div>

      <div class="item data-col-20">
        <h4 class="title" (click)="navigateOrder('Service.serviceName')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Service.serviceName')"></i>
          Nome Servizio
        </h4>
        <span class="data">
          <input type="text" formControlName="Service.serviceName" >  
        </span>
      </div>

      <div class="item data-col-20">
        <h4 class="title" (click)="navigateOrder('Service.pricingModel')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Service.pricingModel')"></i>
          Tipo Servizio
        </h4>
        <span class="data">
          <input type="text" formControlName="Service.pricingModel" >  
        </span>
      </div>

      <div class="item data-col-20">
        <h4 class="title" (click)="navigateOrder('Service.notes')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Service.notes')"></i>
          Note
        </h4>
        <span class="data">
          <input type="text" formControlName="Service.notes" > 
        </span>
      </div>

      <div class="item nowrap">
        <h4 class="title hide-on-mobile">AZIONI</h4>
        <span class="data-row-left btn-container btn-container-actions">
          <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
            RICERCA <i class="fas fa-search"></i></button>
            <br/>
          <button class="btn vertical align-items-center" (click)="fnReset();">
            RESET <i class="fas fa-times-circle"></i></button>
        </span>
      </div>
    </form>

    <div class="table-row-container row" *ngFor="let service of services">
      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          ID
        </h4>
        <div class="data data-id">
          <div>{{ service.id }}</div>
        </div>
      </div>

      <div class="item data-col-10">
        <h4 class="title">Foto</h4>
        <span class="data" style="cursor: pointer;">
          <img 
            [src]="service?.image || 'assets/img/no-image.jpg'" 
            [alt]="service?.serviceName || 'Servizo'"
            class="product-image" 
            (click)="openImage($event)"
          >
        </span>
      </div>

      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          Nome Servizio
        </h4>
        <div class="data">
          <div>{{ service?.serviceName || "N/A" }}</div>
        </div>
      </div>

      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          Tipo Servizio
        </h4>
        <div class="data">
          {{ service?.pricingModel | serviceName }} 
        </div>
      </div>

      <div class="item data-col-10">
        <h4 class="title">
          <i class="sort-icon fas"></i>
          Notes
        </h4>
        <div class="data">
          <div>{{ service?.notes || "N/A" }}</div>
        </div>
      </div>

      <div class="item nowrap">
        <span class="data-row-left btn-container btn-container-actions">
          <button class="btn vertical align-items-center" *ngIf="groups.includes('admin') || groups.includes('operation')" [routerLink]="['/servizi', service.id, 'edit']">
            Modifica
          </button>
          <button class="btn btn-red vertical align-items-center" *ngIf="groups.includes('admin') || groups.includes('operation')" (click)="$event.preventDefault(); deleteService(service.id)">
            Elimina<i class="ml-10 far fa-trash-alt"></i>
          </button>
        </span>
      </div>
    </div>
  </div>
</section>
-->
